// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productSelectorStyles } from "@keller/Overrides/Components/ProductSelector";
import { xScreen } from "@keller/XDL/Utilities";
import { css } from "styled-components";

productSelectorStyles.container = {
    gap: 20,
};

productSelectorStyles.searchGridItem = {
    width: [12, 12, 5, 5, 5],
    css: css`
        position: relative;
    `,
};

productSelectorStyles.qtyGridItem = {
    width: [12, 3, 2, 1, 1],
};

productSelectorStyles.unitOfMeasureGridItem = {
    width: [12, 4, 2, 2, 2],
};

productSelectorStyles.buttonGridItem = {
    width: [12, 5, 3, 4, 4],
};

productSelectorStyles.unitOfMeasureGridItem = {
    width: [9, 9, 3, 3, 3],
    css: css`
        &:empty {
            display: none;
        }
    `,
};

productSelectorStyles.selectButton = {
    css: css`
        margin-top: 25px;
        ${xScreen("lte", "xs")} {
            margin-top: 0;
            width: 100%;
        }
    `,
};

productSelectorStyles.productImage = {
    width: "50px",
    css: css`
        flex-shrink: 0;
    `,
};

productSelectorStyles.clearIcon = {
    css: css`
        position: absolute;
        top: 35px;
        right: 32px;
        width: 30px;
        height: 30px;
        padding: 8px;
        cursor: pointer;
    `,
};

productSelectorStyles.spinner = {
    size: 12,
    css: css`
        margin-right: 8px;
    `,
};
